module.exports = __webpack_public_path__ + "static/media/SAI-logo.aad58391.png";